import React, { Component } from "react"
import { Button, Icon, Affix, message, Menu, Modal, Spin, Select } from "antd"
import { withRouter } from "react-router-dom"
import { observer, inject } from "mobx-react"
import queryString from 'query-string'

const { Option, OptGroup } = Select

@inject("auth", "store") @observer
class DataHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      exportModalShowed: false,
      dayKey: "-1",
    }
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }
  exportDataStep = () => {
    const { exportDataStep } = this.props.store
    this.setState({
      exportModalShowed: true
    })

    exportDataStep()
      .then(
        res => {
          const exportDataUrl = res.url
          this.setState({
            exportModalShowed: false,
          })
          if (document.getElementById("export-a-tag")) document.getElementById("export-a-tag").outerHTML = ""
          let a = document.createElement("iframe")
          a.setAttribute("src", exportDataUrl)
          a.setAttribute("id", "export-a-tag")
          a.setAttribute("style", "display:none;")
          // 防止反复添加
          if (!document.getElementById("export-a-tag")) document.body.appendChild(a)
        },
        err => {
          message.error("导出失败，请您重试！")
          this.setState({
            exportModalShowed: false,
          })
        }
      )

  }
  changeSearch = (e) => {
    if (this.timer) {
      clearTimeout(this.timer)
    }

    const { history, match } = this.props
    const keywords = e.target.value

    this.setState({
      inputSearch: keywords,
    })

    this.timer = setTimeout(() => {
      this.timer = null
      history.push({
        pathname: `${match.url}/search`,
        search: queryString.stringify({ keywords })
      })
    }, 300)
  }

  render() {
    const { list: { totalCount } } = this.props.store

    const dateGroupOptions = [{
      label: '按周选择',
      options: [{ label: '上周', value: 'w_1' }, { label: '上上周', value: 'w_2' }]
    },
    {
      label: '按月选择',
      options: [{ label: '本月', value: 'm_0' }, { label: '上月', value: 'm_1' }, { label: '上上月', value: 'm_2' }]
    }, {
      label: '按季选择',
      options: [{ label: '本季', value: 'q_0' }, { label: '上季', value: 'q_1' }, { label: '上上季', value: 'q_2' }]
    },
    {
      label: '按年选择',
      options: [{ label: '本年', value: 'y_0' }, { label: '上年', value: 'y_1' }]
    }]
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}
      >
        <div className="affix-back">
          <div className="search-time-bar">
            <div className='select-bar-wrap'>
              <Menu className="menu-day" onClick={e => this.onDayChange(e.key)}
                selectedKeys={[this.state.dayKey]}
                mode="horizontal"
                key="menu_date_0">
                <Menu.Item key="-1">
                  <Icon type="calendar" />全部
                  </Menu.Item>
              </Menu>
              <Select
                className='select-day'
                defaultValue="m_0"
                onChange={e => this.onDayChange(e)}
              >
                {dateGroupOptions.map((group, index) =>
                  (
                    <OptGroup label={group.label} key={index}>
                      {group.options.map((option, index) => (
                        <Option key={index} value={option.value}>{option.label}</Option>
                      ))}
                    </OptGroup>
                  )
                )}
              </Select>
            </div>
            {/* <div>

            </div> */}
            <div>
              <span>共 <span className="selected-num">{totalCount}</span> 条数据</span>
              <Button
                className='export-btn'
                type="primary"
                size="default"
                style={{ margin: '0 12px' }}
                onClick={this.exportDataStep}
              >
                <Icon type="download" />下载
            </Button>
            </div>
          </div>
          <Modal
            className="statistics-export-modal"
            width={230}
            visible={this.state.exportModalShowed}
            footer={null}
          >
            <div className="export-loading"><Spin size="large" /></div>
            <div className="export-tips">正在导出中，请稍等。。。</div>
          </Modal>
        </div>
      </Affix>
    )
  }

  onDayChange = (e) => {
    const {
      list: { filterData }
    } = this.props.store
    const dateParamsMap = new Map([
      ['-1', { tab: 'month', option: 0 }],
      ['w_1', { tab: 'week', option: 1 }],
      ['w_2', { tab: 'week', option: 2 }],
      ['m_0', { tab: 'month', option: 0 }],
      ['m_1', { tab: 'month', option: 1 }],
      ['m_2', { tab: 'month', option: 2 }],
      ['q_0', { tab: 'quarter', option: 0 }],
      ['q_1', { tab: 'quarter', option: 1 }],
      ['q_2', { tab: 'quarter', option: 2 }],
      ['y_0', { tab: 'year', option: 0 }],
      ['y_1', { tab: 'year', option: 1 }],
      ['y_2', { tab: 'year', option: 2 }],
    ])
    filterData(dateParamsMap.get(e))
  }
}

export default withRouter(DataHeader)



// WEBPACK FOOTER //
// ./src/app/pages/preview/data_statistics/containers/DataHeader.js